import React from 'react';
import ItemsManager from '../components/items/ItemsManager';

const Items = () => {
  return <ItemsManager />;
};

export default Items;